// extracted by mini-css-extract-plugin
export default {"badges":"DesignerCard_badges__TFQta","badge":"DesignerCard_badge__JG6xZ"};